// A wrong or old address: say so plainly and offer the way back.
import { Link } from "@tanstack/react-router";
import { CurveEdge, Mark } from "../components/brand.tsx";
import { Card, fieldClass, primaryClass, secondaryClass } from "../components/ui.tsx";

export function NotFound() {
	return (
		<div className="min-h-dvh">
			<header className="on-navy bg-navy text-white">
				<div className="mx-auto max-w-[40rem] px-4 pt-[max(env(safe-area-inset-top),1rem)] pb-3">
					<Mark size={36} label="SSG Recruitment Partnerships" className="text-mint" />
					<h1 className="mt-4 font-display text-[1.75rem] leading-tight font-bold">We can't find that page</h1>
				</div>
			</header>
			<CurveEdge />
			<main className="mx-auto max-w-[40rem] px-4 pt-4 pb-16">
				<Card>
					<p className="text-lg">The address may be mistyped, or the page has moved.</p>
					<form action="/candidates" method="get" className="mt-4">
						<label htmlFor="nf-q" className="block font-bold">
							Looking for someone?
						</label>
						<div className="mt-2 flex gap-2">
							<input id="nf-q" name="q" type="search" placeholder="Name, phone or postcode" className={fieldClass} />
							<button type="submit" className={`${secondaryClass} shrink-0`}>
								Find
							</button>
						</div>
					</form>
					<Link to="/" className={`${primaryClass} mt-4`}>
						Go to the home page
					</Link>
				</Card>
			</main>
		</div>
	);
}
